module.exports = __webpack_public_path__ + "static/media/marker-n.9598146c.svg";